import { render } from "./DataConsent.vue?vue&type=template&id=12dd8cba&scoped=true"
import script from "./DataConsent.vue?vue&type=script&lang=js"
export * from "./DataConsent.vue?vue&type=script&lang=js"

import "./DataConsent.vue?vue&type=style&index=0&id=12dd8cba&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12dd8cba"]])

export default __exports__